<app-header [title]="'Passports'" [notificationsCount]="commentsNotification.unreadCount()" [showSearchIcon]="true" [showFilterIcon]="true" [showDesktopFilters]="true" [filterDefinitions]="receiverFilters" (refresh)="onRefresh()"></app-header>

<div class="receiver-page" [style.paddingTop.px]="(ui.searchOpen() || ui.filtersOpen()) ? 0 : 50">
  <!-- Mobile View -->
  <div class="mobile-view">
    <app-receiver-status-tabs [shuntingCount]="shuntingCount"
      [receivingCount]="receivingCount"
      [completedCount]="completedCount"></app-receiver-status-tabs>
    
    <!-- Drag and drop instruction (only show on Shunting tab) -->
    <div class="reorder-instruction" *ngIf="ui.statusSelected() === 'pending'">
      <img src="/assets/images/Info_Orange.png" alt="Info" class="info-icon">
      <span class="instruction-text">Long Press, Drag and Rearrange Passports as required.</span>
    </div>

    <app-no-passports *ngIf="visibleRecords.length === 0"></app-no-passports>

    <ng-container *ngFor="let rec of visibleRecords; trackBy: trackById; let i = index">
      <app-receiver-passport-cell 
        [recordId]="rec.id"
        [loadNumber]="rec.loadNumber || ''"
        [growerName]="rec.growerName || ''"
        [variety]="rec.variety || ''"
        [bulker]="rec.bulker || ''"
        [haulier]="rec.haulier || ''"
        [scheduledText]="rec.dueDateTime ? (rec.dueDateTime | dateWithOrdinal:'EEE, d MMM y, HH:mm') || '' : ''"
        [vendorNumber]="rec.vendorNumber || ''"
        [origin]="rec.origin || ''"
        [destination]="rec.destinationWeighbridge || rec.destination || ''"
        [apn]="rec.apn || ''"
        [apnName]="rec.apnName || ''"
        [vendorName]="rec.vendorName || ''"
        [status]="rec.status"
        [styleState]="rec.pcrChangeAlert ? 'pcr-change' : (rec.statusName?.toLowerCase() === 'cancelled' ? 'cancelled' : 'normal')"
        [isDragging]="draggedRecordId === rec.id"
        [index]="i"
        [draggable]="isShuntingTab"
        (longPressStart)="onLongPressStart(rec.id, $event)"
        (longPressEnd)="onLongPressEnd()"
        (dragStart)="onDragStart(rec.id)"
        (dragEnd)="onDragEnd()"
        (reorder)="onReorder($event.fromIndex, $event.toIndex)">
      </app-receiver-passport-cell>
    </ng-container>
  </div>

  <!-- Desktop View -->
  <div class="desktop-view">
    <!-- Status Buttons Row Template -->
    <ng-template #statusButtonsRow>
      <div class="desktop-status-row">
        <button type="button" class="desktop-status-btn" 
                [class.selected]="ui.statusSelected() === 'pending'"
                (click)="onStatusTabSelect('pending')">
          Shunting ({{ shuntingCount }})
        </button>
        <button type="button" class="desktop-status-btn" 
                [class.selected]="ui.statusSelected() === 'outgoing'"
                (click)="onStatusTabSelect('outgoing')">
          Received ({{ receivingCount }})
        </button>
        <button type="button" class="desktop-status-btn" 
                [class.selected]="ui.statusSelected() === 'completed'"
                (click)="onStatusTabSelect('completed')">
          Completed ({{ completedCount }})
        </button>
        
        <div class="rows-selector-container">
          <button type="button" class="rows-selector-btn" (click)="toggleRowsDropdown($event)">
            <span class="rows-text-group">
              <span class="rows-label">Rows </span>
              <span class="rows-value">{{ itemsPerPage }}</span>
            </span>
            <img src="/assets/images/Chevron_Left.png" class="rows-chevron" alt="expand">
          </button>
          
          <div class="rows-dropdown-menu" *ngIf="rowsDropdownOpen">
            <button type="button" class="rows-option" (click)="setItemsPerPage(10); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(10); $event.stopPropagation()" (keydown.space)="setItemsPerPage(10); $event.stopPropagation(); $event.preventDefault()">10</button>
            <button type="button" class="rows-option" (click)="setItemsPerPage(25); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(25); $event.stopPropagation()" (keydown.space)="setItemsPerPage(25); $event.stopPropagation(); $event.preventDefault()">25</button>
            <button type="button" class="rows-option" (click)="setItemsPerPage(50); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(50); $event.stopPropagation()" (keydown.space)="setItemsPerPage(50); $event.stopPropagation(); $event.preventDefault()">50</button>
            <button type="button" class="rows-option" (click)="setItemsPerPage(100); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(100); $event.stopPropagation()" (keydown.space)="setItemsPerPage(100); $event.stopPropagation(); $event.preventDefault()">100</button>
             <button type="button" class="rows-option" (click)="setItemsPerPage(150); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(150); $event.stopPropagation()" (keydown.space)="setItemsPerPage(150); $event.stopPropagation(); $event.preventDefault()">150</button>
            <button type="button" class="rows-option" (click)="setItemsPerPage(200); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(200); $event.stopPropagation()" (keydown.space)="setItemsPerPage(200); $event.stopPropagation(); $event.preventDefault()">200</button>
            <button type="button" class="rows-option" (click)="setItemsPerPage(250); $event.stopPropagation()" (keydown.enter)="setItemsPerPage(250); $event.stopPropagation()" (keydown.space)="setItemsPerPage(250); $event.stopPropagation(); $event.preventDefault()">250</button>
          </div>
        </div>

        <button type="button" class="desktop-refresh-btn" (click)="onRefresh()">
          Refresh
        </button>
      </div>
    </ng-template>

    <!-- Date Formatting Template -->
    <ng-template #formattedDate let-dueDateTime>
      <div style="display: flex; flex-direction: column; line-height: 1.2;">
        <span>{{ ((dueDateTime | dateWithOrdinal:'EEE, d MMM y, HH:mm') || '-').split(', ').slice(0, 2).join(', ') }}</span>
        <span>{{ ((dueDateTime | dateWithOrdinal:'EEE, d MMM y, HH:mm') || '-').split(', ').slice(2).join(', ') }}</span>
      </div>
    </ng-template>

    <!-- Action Buttons Template -->
    <ng-template #actionButtons let-recordId>
      <app-action-buttons
        [recordId]="recordId"
        (history)="openHistory($event)"
        (comments)="openComments($event)">
      </app-action-buttons>
    </ng-template>

    <!-- Pagination Template -->
    <ng-template #pagination>
      <div class="desktop-pagination">
        <div class="pagination-info">
          <span class="page-range-start">{{ (currentPage - 1) * itemsPerPage + 1 }}</span>
          <span class="page-range-end"> - {{ Math.min(currentPage * itemsPerPage, visibleRecords.length) }} of {{ visibleRecords.length }} Passports</span>
        </div>
        <div class="pagination-controls">
          <label class="page-label" for="receiver-page-select">The page on</label>
          <div class="page-select-wrapper">
            <select id="receiver-page-select" [ngModel]="currentPage" (ngModelChange)="onPageChange(+$event)">
              <option *ngFor="let p of [].constructor(totalPages); let i = index" [value]="i + 1">{{ i + 1 }}</option>
            </select>
          </div>
          <button class="page-nav-btn prev" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
            <img src="/assets/images/Chevron_Left.png" alt="prev">
          </button>
          <button class="page-nav-btn next" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
            <img src="/assets/images/Chevron_Left.png" alt="next" style="transform: rotate(180deg)">
          </button>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="sortedPaginatedRecords.length > 0; else emptyState">
      <!-- Main White Container -->
      <div class="desktop-main-container">
        <!-- Status Buttons Row -->
        <ng-container *ngTemplateOutlet="statusButtonsRow"></ng-container>

        <!-- Drag Instruction -->
        <div class="desktop-drag-instruction" *ngIf="ui.statusSelected() === 'pending'">
          <img src="/assets/images/Info_Orange.png" alt="Info" class="info-icon">
          <span class="instruction-text">Long Press, Drag and Rearrange Passports as required.</span>
        </div>

        <!-- Table Container -->
        <div class="desktop-table-container">
          <table class="desktop-passports-table">
            <thead>
              <tr>
                <th (click)="onSort('loadNumber')" (keydown.enter)="onSort('loadNumber')" (keyup.enter)="onSort('loadNumber')" tabindex="0">Load <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('scheduled')" (keydown.enter)="onSort('scheduled')" (keyup.enter)="onSort('scheduled')" tabindex="0">Scheduled <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('vendorCombined')" (keydown.enter)="onSort('vendorCombined')" (keyup.enter)="onSort('vendorCombined')" tabindex="0">Vendor Number/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('variety')" (keydown.enter)="onSort('variety')" (keyup.enter)="onSort('variety')" tabindex="0">Variety <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('origin')" (keydown.enter)="onSort('origin')" (keyup.enter)="onSort('origin')" tabindex="0">Origin <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('destination')" (keydown.enter)="onSort('destination')" (keyup.enter)="onSort('destination')" tabindex="0">Destination <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('haulier')" (keydown.enter)="onSort('haulier')" (keyup.enter)="onSort('haulier')" tabindex="0">Haulier <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('apnName')" (keydown.enter)="onSort('apnName')" (keyup.enter)="onSort('apnName')" tabindex="0">APN/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('bulkerNumber')" (keydown.enter)="onSort('bulkerNumber')" (keyup.enter)="onSort('bulkerNumber')" tabindex="0">Bulker Number <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rec of sortedPaginatedRecords; trackBy: trackById; let i = index" 
                  [attr.data-passport-id]="rec.id"
                  [draggable]="isShuntingTab && !sortColumn && desktopDragActiveRecordId === rec.id" 
                  (mouseenter)="onDesktopMouseEnter(rec.id)"
                  (mouseleave)="onDesktopMouseLeave()"
                  (mousedown)="onDesktopMouseDown(rec.id, $event)"
                  (mouseup)="onDesktopMouseUp()"
                  (dragstart)="onDesktopDragStart($event, rec.id, i)" 
                  (dragover)="onDesktopDragOver($event)" 
                  (drop)="onDesktopDrop($event, i)"
                  (dragend)="onDesktopDragEnd()"
                  [class.dragging]="draggedRecordId === rec.id"
                  [class.has-pcr-changes]="rec.pcrChangeAlert && rec.statusName?.toLowerCase() !== 'cancelled'"
                  [class.is-cancelled]="rec.statusName?.toLowerCase() === 'cancelled'">
                <td class="col-load-number" 
                    (click)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                    (keydown.enter)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                    (keyup.enter)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                    [tabindex]="rec.statusName?.toLowerCase() !== 'cancelled' ? 0 : -1">
                  <div class="load-cell-content">
                    <!-- Show drag handle on hover or when actively dragging -->
                    <img *ngIf="isShuntingTab && !sortColumn && (desktopHoveredRecordId === rec.id || desktopDragActiveRecordId === rec.id)" 
                         src="/assets/images/Drag_Drop_Icon.png" 
                         class="drag-handle pop-in" 
                         alt="drag">
                    <span class="load-text">{{ store.get(rec.id)?.loadNumber || rec.id }}</span>
                  </div>
                </td>
                  <td>
                    <ng-container *ngTemplateOutlet="formattedDate; context: { $implicit: store.get(rec.id)?.dueDateTime }"></ng-container>
                  </td>
                  <td>{{ (store.get(rec.id)?.vendorNumber || '-') + ' - ' + (store.get(rec.id)?.vendorName || '-') }}</td>
                  <td>{{ store.get(rec.id)?.variety || '-' }}</td>
                <td>{{ store.get(rec.id)?.origin || 'No Origin Field' }}</td>
                <td>{{ store.get(rec.id)?.destinationWeighbridge || store.get(rec.id)?.destination || '-' }}</td>
                  <td>{{ store.get(rec.id)?.haulier || '-' }}</td>
                  <td>{{ store.get(rec.id)?.apnName || store.get(rec.id)?.apn || '-' }}</td>
                  <td>{{ store.get(rec.id)?.bulkerMain || store.get(rec.id)?.bulkerNumber || '-' }}</td>
                  <ng-container *ngTemplateOutlet="actionButtons; context: { $implicit: rec.id }"></ng-container>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <ng-container *ngTemplateOutlet="pagination"></ng-container>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="desktop-empty-container">
        <div class="desktop-main-container empty-state-header">
          <ng-container *ngTemplateOutlet="statusButtonsRow"></ng-container>
        </div>

        <app-desktop-empty-state></app-desktop-empty-state>
      </div>
    </ng-template>
  </div>
</div>

<app-loading-spinner [isLoading]="isLoading()" [largeOnDesktop]="true" text="Loading passports…"></app-loading-spinner>

<app-navbar [items]="navbarItems" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>
